import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { FormioPipesModule } from 'src/formio-custom-components/src/lib/shared/pipes';
import { CustomSelectComponent } from './custom-select.component';

@NgModule({
	declarations: [CustomSelectComponent],
	entryComponents: [CustomSelectComponent],
	exports : [CustomSelectComponent],
	imports: [
		CommonModule,
		TranslateModule,
		FormsModule,
		ReactiveFormsModule,
		FormioPipesModule,
		NgSelectModule,
	],
})
export class CustomSelectModule {}
